import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { ScopeVersion } from '@app/core/model/scope-version'
import { User } from '@app/core/model/user.model'

export const isChangeRequestEnabled = (scope: ScopeVersion, user: User): boolean =>
  scope &&
  scope.isStateApproved() &&
  !scope.isScopeByRole() &&
  user &&
  user.company?.hasApplicationSetting(ApplicationSetting.CHANGE_REQUEST) &&
  user.company?.hasApplicationSetting(ApplicationSetting.SCOPE__ENABLE_CHANGE_REQUEST)
